import React from 'react'
import CountryPhoneInput, { ConfigProvider } from 'antd-country-phone-input'
import en from 'world_countries_lists/data/countries/en/world.json'
import { COUNTRY_CODES } from '../../../consts'

const CountryCodePhonInput = ({
  errorText,
  countryCodes = COUNTRY_CODES,
  ...others
}) => {
  const areasNotIncluded = 'CA'
  return (
    <div className="phone-input-wrapper">
      <ConfigProvider
        locale={en}
        areaFilter={area => {
          const isValidCode = countryCodes.includes(area.phoneCode)

          return isValidCode && area.short !== areasNotIncluded
        }}
        areaMapper={area => {
          return {
            ...area,
            emoji: '',
          }
        }}
      >
        <CountryPhoneInput inline {...others} />
      </ConfigProvider>
    </div>
  )
}

export default CountryCodePhonInput
